<template>
  <!-- 这个是基本信息 -->
  <div class="main">
    <div class="list_box">
      <div class="list_title">
        {{ $t("account_management.information.developer") }}
      </div>
      <div class="list_text">{{ dataInfo.nickname }}</div>
    </div>

    <div class="list_box">
      <div class="list_title">
        {{ $t("account_management.information.progress") }}
      </div>
      <div class="list_progress_box">
        <div class="progress_box">
          <div class="progress" :style="'width:' + process + '%'">
            {{ process }}%
          </div>
        </div>
      </div>
    </div>
    <div class="list_box">
      <div class="list_title">
        <span class="must">*</span>
        {{ $t("account_management.information.type") }}
      </div>
      <div class="list_text">
        {{
          radio == 0
            ? $t("account_management.information.individual_person")
            : $t("account_management.information.company")
        }}
        <span class="text">
          ({{ $t("account_management.information.email") }}
          <span class="copy CU" @click="copy(configs)"
            >{{ configs }}{{ $t("account_management.information.copy") }}</span
          >
          )
        </span>
      </div>
    </div>

    <div class="list_box name MG25" v-if="radio == 0">
      <div class="list_title">
        <span class="must">*</span>
        {{ $t("account_management.information.name") }}
      </div>
      <div :class="compellations && !compellation.lastname ? 'TGA_BR' : ''">
        <input
          v-model="compellation.lastname"
          class="TGA_INPUT input"
          type="text"
        />
      </div>
      <div class="">
        <span class="must">*</span>
        {{ $t("account_management.information.surname") }}
      </div>
      <div :class="compellations && !compellation.firstname ? 'TGA_BR' : ''">
        <input
          v-model="compellation.firstname"
          class="TGA_INPUT input"
          type="text"
        />
      </div>

      <div class="TGA_INPUT_INIT" style="height: 40px" v-if="compellations">
        <img width="15" height="15" src="@/img/mistake.png" alt="" />
        <span>{{ $t("account_management.information.empty_name") }}</span>
      </div>
    </div>

    <!-- v-if="radio == 1" :class="accountNames?'TGA_BR':''"  v-model="accountName" v-if="accountNames"-->
    <div
      class="list_box MG25 wid367"
      v-if="radio == 1"
      :class="accountNames ? 'TGA_BR' : ''"
    >
      <div class="list_title">
        <span class="must">*</span>
        {{ $t("account_management.information.enterprise") }}
      </div>
      <div>
        <input type="text" v-model="accountName" class="TGA_INPUT input367" />
      </div>
      <div class="TGA_INPUT_INIT" style="height: 40px" v-if="accountNames">
        <img width="15" height="15" src="@/img/mistake.png" alt="" />
        <span>{{ $t("account_management.information.empty_enterprise") }}</span>
      </div>
    </div>

    <div class="list_box name MG25 elm_site">
      <div class="list_title">
        <span class="must">*</span>
        {{ $t("account_management.information.location") }}
      </div>
      <div
        :class="location && country == null ? 'TGA_BR' : ''"
        style="width: 117px"
      >
        <el-select
          class=""
          v-model="country"
          @change="(province = null), (city = null)"
          :placeholder="$t('account_management.information.select')"
        >
          <el-option
            v-for="(item, index) in product"
            :key="index"
            :label="item.country"
            :value="index"
          ></el-option>
        </el-select>
      </div>
      <div :class="location && province == null ? 'TGA_BR' : ''">
        <el-select
          class=""
          v-model="province"
          @change="city = null"
          :placeholder="$t('account_management.information.select')"
        >
          <el-option
            v-for="(item, index) in typeArray"
            :key="index"
            :label="item.province"
            :value="index"
          ></el-option>
        </el-select>
      </div>
      <div :class="location && city == null ? 'TGA_BR' : ''">
        <el-select
          class=""
          v-model="city"
          :placeholder="$t('account_management.information.select')"
        >
          <el-option
            v-for="(item, index) in nameArray"
            :key="index"
            :label="item.city"
            :value="index"
          ></el-option>
        </el-select>
      </div>

      <div class="TGA_INPUT_INIT" style="height: 40px" v-if="location">
        <img width="15" height="15" src="@/img/mistake.png" alt="" />
        <span>{{ $t("account_management.information.select_location") }}</span>
      </div>
    </div>

    <div class="list_box MG25 wid367" :class="sites ? 'TGA_BR' : ''">
      <div class="list_title">
        <span class="must">*</span>
        {{ $t("account_management.information.site") }}
      </div>
      <div><input type="text" v-model="site" class="TGA_INPUT input367" /></div>
      <div class="TGA_INPUT_INIT" style="height: 40px" v-if="sites">
        <img width="15" height="15" src="@/img/mistake.png" alt="" />
        <span>{{ $t("account_management.information.select_site") }}</span>
      </div>
    </div>

    <div class="list_box MG25">
      <div class="list_title">
        {{ $t("account_management.information.phone") }}
      </div>
      <div class="list_select">
        <el-select
          class="phone_select"
          v-model="area"
          :placeholder="$t('account_management.information.select')"
        >
          <el-option
            v-for="(item, index) in configarea"
            :key="index"
            :label="item"
            :value="index"
          ></el-option>
        </el-select>

        <div class="ipone_box">
          <span class="ipone" v-if="phonetext">{{ amend(phonetext) }}</span>
          <span class="ipone_amend CU" @click="modification">{{
            $t("account_management.information.alter")
          }}</span>
        </div>
      </div>
    </div>

    <div class="list_box MG25" v-if="showphone">
      <div>
        <input
          type="number"
          v-model="phone"
          :placeholder="$t('account_management.information.select_phone')"
          class="TGA_INPUT input367"
        />
      </div>
    </div>

    <div class="CU btn" @click="sendmsg">
      {{ $t("account_management.information.save") }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configarea from "@/config/area.json";
import configsite from "@/config/site.json";
import configs from "@/utils/config.js";
export default {
  data() {
    return {
      configs: configs.serviceEmail(),
      configarea: configarea,
      dataInfo: "",
      showphone: false,
      compellation: {
        firstname: null,
        lastname: null,
      },
      // 国家
      country: null,
      // 省
      province: null,
      // 市
      city: null,
      //地址
      site: null,
      // 电话
      phone: null,
      phonetext: null,
      // 电话区号
      area: null,
      accountName: null,
      location: false,
      compellations: false,
      names: false,
      sites: false,
      accountNames: false,
      product: configsite,
      radio: 0,
      process: 0,
    };
  },
  created() {
    this.BaseInfo();
  },
  computed: {
    //获取国家
    typeArray() {
      return this.country !== null ? this.product[this.country].type : null;
    },
    // 获取省
    nameArray() {
      return this.province !== null && this.typeArray.length
        ? this.typeArray[this.province].name
        : null;
    },
  },
  methods: {
    ...mapActions("user", ["tipMessage", "getUserInfo", "updateUserInfoExt"]),
    // 获取基本信息
    async BaseInfo() {
      var res = await this.getUserInfo({
        $axios: this.$axios,
      });
      if (res.code == 200) {
        var data = res.data.extInfo.baseInfo;
        this.country = data.area.country;
        this.province = data.area.province;
        this.city = data.area.city;
        if (data.groupType == 0) {
          this.compellation = data.groupName;
        } else {
          this.accountName = data.groupName.company;
        }
        this.radio = data.groupType;
        this.area = data.countryCode;
        this.phonetext = data.phone;
        this.site = data.address;
        this.dataInfo = res.data;

        var idIdInfo = JSON.parse(res.data.extInfo.idIdInfo || "{}");
        if (idIdInfo.idName) {
          this.process = 100;
        } else {
          this.process = 50;
        }
      }
    },

    // 点击保存
    async sendmsg() {
      if (!this.check()) {
        return;
      }

      var phone = "";

      if (this.showphone && this.phone != null) {
        phone = this.phone;
      } else {
        phone = this.phonetext;
      }
      var area = {
        province: this.province,
        city: this.city,
        country: this.country,
      };
      var obj = {
        groupType: Number(this.radio),
        groupName: "",
        area: area,
        phone: phone,
        countryCode: this.area,
        address: this.site,
      };
      if (this.radio == 0) {
        obj.groupName = this.compellation;
      } else {
        obj.groupName = { company: this.accountName };
      }
      console.log("obj", obj);
      var res = await this.updateUserInfoExt({
        $axios: this.$axios,
        key: "baseInfo",
        value: obj,
      });
      if (res.code == 200) {
        this.tipMessage({
          context: this.$t("account_management.information.save_success"),
        });
        if (this.phone != "") {
          this.phonetext = phone;
          this.phone = null;
          this.showphone = false;
        }
      }
    },

    check() {
      var switchs = true;
      this.compellations = false;
      this.location = false;
      this.sites = false;
      this.accountNames = false;
      if (this.radio == 0) {
        if (!this.compellation.lastname || !this.compellation.firstname) {
          this.compellations = true;
          switchs = false;
        }
      } else {
        if (!this.accountName) {
          this.accountNames = true;
          switchs = false;
        }
      }
      if (this.country == null || this.province == null || this.city == null) {
        this.location = true;
        switchs = false;
      }
      if (!this.site) {
        this.sites = true;
        switchs = false;
      }
      return switchs;
    },

    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(this.$t("account_management.information.copysuccess"));
      // this.$message({
      //   message: '复制成功',
      //   type: 'success'
      // });
      oInput.remove();
    },
    // 点击修改
    modification() {
      //            this.tipMessage({
      //              context: '修改成功'
      //            });
      //
      this.showphone = true;
    },
    amend(data) {
      console.log("11111111111111111111");
      console.log(data);
      return data.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
    },

    // Array(item){
    //   var d = item;
    //   var c = '广东';
    //   var e = '广州';
    //   console.log('来了啊')
    //   for (var i = 0; i < this.product.length; i++) {
    //     if (this.product[i].country == d) {
    //       this.country = i;
    //       for (var j = 0; j < this.product[i].type.length; j++) {
    //         if (this.product[i].type[j].province == c) {
    //           this.province = j;
    //           for (var k = 0; k < this.product[i].type[j].name.length; k++) {
    //             if (this.product[i].type[j].name[k].city == e) {
    //               this.city = k;
    //               break;
    //             }
    //           }
    //           break;
    //         }
    //       }
    //       break;
    //     }
    //   }
    //   return
    // },
  },
};
</script>

<style scoped="scoped">
.main {
  box-sizing: border-box;
  padding: 50px 0 90px 250px;
}
.list_box {
  height: 40px;
  position: relative;
  color: #666666;
  font-size: 14px;
}
.list_title {
  width: 220px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  position: absolute;
  left: -250px;
  top: 0;
}
.list_text {
  height: 40px;
  line-height: 40px;
}
.list_progress_box {
  height: 40px;
  display: flex;
  align-items: center;
}
.progress_box {
  box-sizing: border-box;
  width: 301px;
  height: 15px;
  background-color: #f3f3f3;
  border-radius: 2px;
  border: solid 1px #e5e5e5;
}
.progress {
  width: 50%;
  height: 100%;
  color: #ffffff;
  background-color: #23d3be;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list_text .text {
  color: #f65651;
  font-size: 12px;
}
.list_text .text .copy {
  color: #4990fa;
}
.main .input {
  width: 136px;
  height: 40px;
}
.name {
  width: 367px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ipone_box {
  margin-left: 16px;
}
.ipone {
  font-size: 14px;
  color: #282828;
}
.ipone_amend {
  font-size: 14px;
  color: #4990fa;
}

.btn {
  width: 367px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 16px;
  margin-top: 30px;
}
.phone_select {
  border-radius: 0;
  height: 40px;
  width: 84px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-left: 0;
}
</style>
<style>
.phone_BOX .el-input__inner {
  box-sizing: border-box;
  height: 40px;
  /* border: none; */
  padding-left: 15px;
  font-size: 14px;
  color: rgba(28, 28, 28, 1);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e5e5e5;
  padding-right: 25px;
}
.phone_BOX .el-input__suffix {
  right: 0;
}
.TGA_BR .el-input__inner {
  border: solid 1px #f65651 !important;
}

.elm_site .el-input__inner {
  box-sizing: border-box;
  width: 117px;
  height: 40px;
  /* border: none; */
  padding-left: 15px;
  font-size: 14px;
  color: rgba(28, 28, 28, 1);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e5e5e5;
  padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/account_management/information.vue